export default __webpack_public_path__ + "static/media/PeugeotNew-Bold.032896e0.otf";